import MatchHeight from "vanilla-js-match-height";

export default function Heights() {
	new MatchHeight(".js-product-name");
	new MatchHeight(".js-product-price");
	new MatchHeight(".js-product-card");
	new MatchHeight(".js-post-heading");
	new MatchHeight(".js-whitepaper-heading");
	new MatchHeight(".js-whitepaper-content");
	new MatchHeight(".c-country");
	new MatchHeight(".c-sub-menu__card");
	new MatchHeight(".js-global-coverage-networks");
}
